import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=e479db88&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e479db88')) {
      api.createRecord('e479db88', component.options)
    } else {
      api.reload('e479db88', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=e479db88&", function () {
      api.rerender('e479db88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iGDHaPYP8nGo/JS/comp/starrating.vue"
export default component.exports